// Main entry — the ProgramConfiguration View. It owns no fetch; the draft
// config values + setters come in as props from ProgramDetail (they feed the
// BuilderConfig). Sim wrappers live under ./sim and are never imported here.
export { ProgramConfiguration } from "./ProgramConfiguration";
export type { ProgramConfigurationProps } from "./ProgramConfiguration";
